import { render, staticRenderFns } from "./verify_request.vue?vue&type=template&id=b2115dc2"
import script from "./verify_request.vue?vue&type=script&lang=js"
export * from "./verify_request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports